<template>
    <k-dialog @close="cancel" title="Entry Details" :width="500">
        <div class="k-form k-form-horizontal">
            <div class="k-form-field">
                <label for="employeeFirstName" class="k-form-label">First Name</label>
                <div class="k-form-field-wrap">
                    <k-input type="text" :readonly=false :name="'employeeFirstName'" v-model="entryInEdit.employeeFirstName" class="text-input"></k-input>
                </div>
            </div>
            <div class="k-form-field">
                <label for="employeeLastName" class="k-form-label">Last Name</label>
                <div class="k-form-field-wrap">
                    <k-input type="text" :readonly=true :name="'employeeLastName'" v-model="entryInEdit.employeeLastName" class="text-input"></k-input>
                </div>
            </div>
            <div class="k-form-field">
                <label for="supervisor" class="k-form-label">Supervisor</label>
                <div class="k-form-field-wrap">
                    <k-input type="text" :readonly=true :name="'supervisor'" v-model="entryInEdit.supervisor" class="text-input"></k-input>
                </div>
            </div>
            <div class="k-form-field">
                <label for="company" class="k-form-label">Company</label>
                <div class="k-form-field-wrap">
                    <k-input type="text" :readonly=true :name="'company'" v-model="entryInEdit.company" class="text-input"></k-input>
                </div>
            </div>
            <div class="k-form-field">
                <label for="branchName" class="k-form-label">Branch</label>
                <div class="k-form-field-wrap">
                    <select class="form-control"
                            v-model="entryInEdit.branchName"
                            @change="onChangeBranch"
                            name="branchName">
                        <option v-for="item in branches"
                                :value="item.branchName"
                                :key="item.branchName">
                            {{ item.branchName }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="k-form-field">
                <label for="department" class="k-form-label">Department</label>
                <div class="k-form-field-wrap">
                    <select class="form-control"
                            v-model="entryInEdit.branchLocationId"
                            name="branchLocationId">
                        <option v-for="item in this.branchLocations" :value="item.id" :key="item.id">
                            {{ item.Name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="k-form-field">
                <label for="area" class="k-form-label">Area</label>
                <div class="k-form-field-wrap">
                    <k-input type="text" :readonly=true :name="'area'" v-model="entryInEdit.area" class="text-input"></k-input>
                </div>
            </div>
            <div class="k-form-field">
                <label for="equipment" class="k-form-label">Equipment</label>
                <div class="k-form-field-wrap">
                    <k-input type="text" :readonly=true :name="'equipment'" v-model="entryInEdit.equipment" class="text-input"></k-input>
                </div>
            </div>
            <div class="k-form-field">
                <label for="dateSubmitted1" class="k-form-label">Date of Event</label>
                <div class="k-form-field-wrap">
                    <k-input type="text" :name="'dateSubmitted1'" v-model="entryInEdit.dateSubmitted1" class="text-input"></k-input>
                </div>
            </div>
            <div class="k-form-field">
                <label for="timeSubmitted" class="k-form-label">Time of Event</label>
                <div class="k-form-field-wrap">
                    <k-input type="text" :name="'timeSubmitted'" v-model="entryInEdit.timeSubmitted" class="text-input"></k-input>
                </div>
            </div>
            <div class="k-form-field">
                <label for="reason" class="k-form-label">Category</label>
                <div class="k-form-field-wrap">
                    <k-input type="text" :readonly=true :name="'reason'" v-model="entryInEdit.reason" class="text-input"></k-input>
                </div>
            </div>
            <div class="k-form-field">
                <label for="nearMiss" class="k-form-label">Near Miss</label>
                <div class="k-form-field-wrap">
                    <k-input type="text" :name="'nearMiss'" :readonly=true v-model="entryInEdit.nearMiss" class="text-input"></k-input>
                </div>
            </div>
            <div class="k-form-field">
                <label for="nearMissType" class="k-form-label">Near Miss Type</label>
                <div class="k-form-field-wrap">
                    <k-input type="text" :name="'nearMissType'" :readonly=true v-model="entryInEdit.nearMissType" class="text-input"></k-input>
                </div>
            </div>
            <div class="k-form-field">
                <label for="description" class="k-form-label">Description</label>
                <div class="k-form-field-wrap">
                    <k-textarea :style="{ minHeight: '80px'  }" :readonly=true :name="'description'"
                                fillmode='solid'
                                v-model="entryInEdit.description" class="text-input"></k-textarea>
                </div>
            </div>
            <div class="k-form-field">
                <label for="correctiveAction" class="k-form-label">Action Taken</label>
                <div class="k-form-field-wrap">
                    <k-textarea :style="{ minHeight: '80px'  }" :readonly=true :name="'correctiveAction'"
                                fillmode='solid'
                                v-model="entryInEdit.correctiveAction" class="text-input"></k-textarea>
                </div>
            </div>
            <!-- TODO: Refactor so this comes from the DB instead of being hardcoded-->
            <div class="k-form-field-wrap">
                <RadioGroup class="status-label ui-element"
                            v-model="entryInEdit.isApproved"
                            :data-items="statusItems" />
            </div>
            <div v-if="entryInEdit.isApproved === 0" class="k-form-field ui-element">
                <label for="rejectReason" class="k-form-label">Rejection Action</label>
                <select id="rejectReason"
                        v-model="entryInEdit.rejectionId"
                        class="form-control">
                    <option v-for="action in rejectionActions"
                            :key="action.id"
                            :value="action.id">
                        {{ action.reason }}
                    </option>
                </select>
            </div>
        </div>
        <dialog-actions-bar  v-if="store.isApprover" :layout="'start'">
            <kbutton :theme-color="'primary'" @click="save" :svg-icon="saveIcon" class="ui-element"> Save </kbutton>&nbsp;
            <kbutton @click="cancel" :svg-icon="cancelIcon" class="ui-element"> Cancel </kbutton>
        </dialog-actions-bar>
    </k-dialog>
</template>
<style scoped>
    .k-form-label, .k-input, .ui-element {
        font-size: 12pt;
    }
    .text-input, .form-control {
        width: 300px;
    }
    :deep(.k-dialog-title) {
        font-size: 14pt;
        font-weight: bold;
    }
    :deep(.k-radio) {
        width: 20px;
        height: 20px;
    }
    .status-label {
        margin-left: 8px;
        margin-right: 24px;
        display: flex;
        flex-direction: row;
        gap: 24px;
    }
</style>
 <script>
    import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs'
    import { Input, TextArea } from '@progress/kendo-vue-inputs'
    import { Button } from '@progress/kendo-vue-buttons'
    import { cancelIcon, saveIcon, trashIcon } from '@progress/kendo-svg-icons'
    import { store } from '../stores/store.js';
    import axios from 'axios'
    import { RadioGroup } from '@progress/kendo-vue-inputs';

    export default {
        components: {
            'k-input': Input,
            'k-textarea': TextArea,
            'k-dialog': Dialog,
            'dialog-actions-bar': DialogActionsBar,
            kbutton: Button,
            RadioGroup
          },
        props: {
            dataItem: Object,
            statuses: Array,
        },
        data: function () {
            return {
                cancelIcon,
                saveIcon,
                trashIcon,
                rejectionActions: [],
                entryInEdit: {
                    id: 0,
                    employeeNumber: '',
                    employeeFirstName: '',
                    employeeLastName: '',
                    supervisor: '',
                    reason: '',
                    name: '',
                    description: '',
                    dateSubmitted1: '',
                    whsCode: '',
                    company: '',
                    area: '',
                    equipment: '',
                    nearMiss: '',
                    nearMissType: '',
                    correctiveAction: '',
                    branchName: '',
                    department: '',
                    isApproved: true,
                    branchLocationId: 0,
                },
                store,
                branches: [],
                branchLocations: [],
        };
    },
        computed: {
            statusItems() {
                return this.statuses.map(status => ({
                    label: status.title,
                    value: status.id
                }));
            }
        },

        created: function () {
            if (this.$props.dataItem) {
                this.entryInEdit = this.$props.dataItem;
            }
        },
        mounted() {
            this.getAllBranches();
            this.getLocationsByBranch();
            this.loadRejectionActions();
        },
        methods: {
            save() {
                this.$emit('save');
            },
            reject() {
                this.$emit('reject');
            },
            cancel() {
                this.$emit('cancel');
            },
            async loadRejectionActions() {
                const response = await axios.get('/sharpEntries/rejectionActions');
                this.rejectionActions = response.data;
            },
            async getAllBranches() {

                axios.post('/sharpBranch/getAllBranches')
                    .then((response) => {
                        this.branches = response.data;
                });
            },
            async getLocationsByBranch() {

                if (this.entryInEdit.branchName === '') {
                    return;
                }
                axios.post('/sharpBranch/getLocationsByBranch', { branchName: this.entryInEdit.branchName })
                    .then((response) => {
                        this.branchLocations = response.data;
                });
            },
            onChangeBranch() {
                this.getLocationsByBranch();
            },
        },
    }
</script>